export const rivenAuthCookieKey = '_riven';
export const deviceFlowXsrfCookieKey = '_riven_device_flow_xsrf';
